/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelRapidAlertCtrl.ts                *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/dispatch/rapid-alert-ctrl";

export class AutogenModelRapidAlertCtrl<RowType extends ModelRow> extends Endpoint<RowType, RowRapidAlertCtrlFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowRapidAlertCtrl extends ModelRow<RowRapidAlertCtrlFields> {
	constructor(values?: Partial<RowRapidAlertCtrlFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowRapidAlertCtrlFields {
	company_id: string;
	days: number;
	id: number;
	reply_to_email: string;
}

